// extracted by mini-css-extract-plugin
var _1 = "iconButton__AN84d";
export { _1 as "iconButton" }
export default { "iconButton": _1 }
